import { api } from './client'

export const checkInAPI = {
  checkIn: (entityId, isLive, liveUntil = null) =>
    api.post(`/entities/${entityId}/check-in`, { isLive, liveUntil }),
}
